
import React,{useState, Component, useEffect, useRef} from 'react';
import {Button, Row, Container, Col, Form, Table, InputGroup, OverlayTrigger, Tooltip, Breadcrumb, Card, CardColumns, Modal} from 'react-bootstrap';

const PageFuction = (props) => {
  return (
    <>
    <section>
        <Container style={{display:"table",minHeight:"180px"}}>
            <div className="" style={{display:"table-cell",verticalAlign:"middle", fontSize:"40px"}}>
                รายงานภาพรวม (รายเดือน) ประจำปี
            </div>
        </Container>
    </section>
    <img src="appDefault/graph_car.png" className="responsive" alt="Uploaded Images" style={{maxHeight:"100%",maxWidth:"100%"}} />
    </>
  );
}

class Page extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <PageFuction firebase={this.props.firebase} />
    );
  }
}

export default Page;